import React, { useState, useEffect } from "react";
import { postApiWithAuth } from "../../../services/api/api";

const NotificationTab = () => {
    const [notifications, setNotifications] = useState([]);

    // Isolated tracking implementation pattern on full mount lifecycle
    useEffect(() => {
        const fetchNotificationsData = async () => {
            try {
                const storedProfileStr = localStorage.getItem("profile_data");
                let userId = 1;
                if (storedProfileStr) {
                    const parsed = JSON.parse(storedProfileStr);
                    const profile = Array.isArray(parsed) ? parsed[0] : parsed;
                    userId = profile?.id || profile?.user_id || 1;
                }

                // Updated to call your local authenticated POST function
                const response = await postApiWithAuth("/notification-list", { user_id: userId });
                const list = Array.isArray(response) ? response : (response?.data || response?.notifications || []);
                setNotifications(list);
            } catch (error) {
                console.error("Error loading notification records via authenticated API:", error);
            }
        };
        fetchNotificationsData();
    }, []);

    const renderTimestamp = (dateString) => {
        if (!dateString) return "Recent";
        const dateObj = new Date(dateString);
        if (isNaN(dateObj.getTime())) return dateString;

        return (
            <>
                {dateObj.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
                <br />
                {dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}
            </>
        );
    };

    return (
        <div className="tab-content-box">
            <div className="row">
                <div className="col-lg-12">
                    <h2 className="section-title">Notification</h2>
                    <div className="info-card">
                        {notifications.length > 0 ? (
                            notifications.map((item, index) => (
                                <div className="notification-item" key={item.id || index}>
                                    <div className="d-flex align-items-start justify-content-between">
                                        <div className="d-flex align-items-start">
                                            <div className="notify-icon">i</div>
                                            <div>
                                                <h6 className="notif-title">{item.title || item.heading || "Notification"}</h6>
                                                <p className="notif-subtitle">{item.description || item.subtitle || item.message || ""}</p>
                                            </div>
                                        </div>
                                        <p className="notif-subtitle text-end">
                                            {renderTimestamp(item.created_at || item.date)}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-muted text-center py-4">No notifications found</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationTab;